import React from 'react';
import { Row, Col } from 'antd';
import CourseCardSkeleton from '../CourseCard/CourseCardSkeleton';
import { GridType } from '../../types';

const TCourseCardListSkeleton: React.FC<GridType> = ({ row, col }) => {
  return (
    <Row {...row}>
      {Array(20)
        .fill(undefined)
        .map((value, index) => (
          <Col key={index} {...col}>
            <CourseCardSkeleton />
          </Col>
        ))}
    </Row>
  );
};

export default TCourseCardListSkeleton;
